// extracted by mini-css-extract-plugin
export default {"title":"FavoritePage_title__-+0Ef"};